// frontend/components/POS/PaymentMethods.jsx
import React from 'react';
import { BanknotesIcon, DevicePhoneMobileIcon, CreditCardIcon, DocumentTextIcon } from '@heroicons/react/24/outline';

const methods = [
  { id: 'cash', name: 'Cash', icon: BanknotesIcon, color: 'bg-green-100 text-green-700' },
  { id: 'mpesa', name: 'M-Pesa', icon: DevicePhoneMobileIcon, color: 'bg-purple-100 text-purple-700' },
  { id: 'card', name: 'Card', icon: CreditCardIcon, color: 'bg-blue-100 text-blue-700' },
  { id: 'credit', name: 'Credit', icon: DocumentTextIcon, color: 'bg-yellow-100 text-yellow-700' },
];

export default function PaymentMethods({ selected, onChange }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {methods.map((method) => (
        <button
          key={method.id}
          onClick={() => onChange(method.id)}
          className={`p-3 rounded-lg border-2 transition-all ${
            selected === method.id
              ? `${method.color} border-current`
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <method.icon className="h-6 w-6 mx-auto mb-1" />
          <div className="text-sm font-medium">{method.name}</div>
        </button>
      ))}
    </div>
  );
}